// extracted by mini-css-extract-plugin
export default {"wrapper":"ReferralLink_wrapper__Dq7hF","form":"ReferralLink_form__oTBuU","emailWrapper":"ReferralLink_emailWrapper__Iq5+2","itemWrapper":"ReferralLink_itemWrapper__7NjjX"};